import moment from "moment";
import React, { useState } from "react";
import { Link } from "react-router-dom";
import { MoneyFormat, useWindowsSize } from "../../libs";
import Loading from "../../components/Main/Loading";

function History({ props }) {
  const {
    isHistory,
    loadingHistory,
    onPagination,
    onFilter,
    isMenu,
    loadMore,
  } = props;
  const size = useWindowsSize();

  const [isShow, setShow] = useState({ index: null, view: false });

  return loadingHistory ? (
    <Loading />
  ) : isMenu === 1 && isHistory.length === 0 ? (
    <div className="w-full mt-10 flex flex-row content-center justify-center">
      <div className="lg:w-1/3">
        <div className="w-full flex justify-center">
          <img
            className="mb-8 w-4/5"
            src={
              process.env.REACT_APP_BASE_URL + "/assets/icon/ic_empty_box.svg"
            }
            alt="icon-empty-cart"
          />
        </div>
        <div className="w-full">
          <p className="header-content text-center colors-blue text-xl font-semibold mb-4">
            History Transaksi Kosong
          </p>
          <p className="header-content text-center colors-gray text-base mb-8">
            Transaksi anda masih kosong, silahkan menambahkan pembelanjaan anda
          </p>
        </div>
        <Link to={"/"}>
          <div className="flex justify-center">
            <button className="btn-blue w-full lg:w-4/5 p-3 focus:outline-none mb-8">
              <p className="text-white lg:text-lg">Mulai Belanja</p>
            </button>
          </div>
        </Link>
      </div>
    </div>
  ) : (
    <div className="history grid grid-cols-1 lg:grid-cols-5 grid-rows-1 gap-2 lg:gap-10">
      {/* Left Content */}
      {size.width > 640 ? (
        <div>
          <div
            onClick={() => onFilter(1, 1)}
            className={`cursor-pointer ${
              isMenu === 1
                ? "menu-active text-white"
                : "menu-nonactive colors-blue"
            } p-3 text-center font-semibold tracking-wider `}
          >
            Semua Pesanan
          </div>
          <div
            onClick={() => onFilter(1, 2)}
            className={`cursor-pointer ${
              isMenu === 2
                ? "menu-active text-white"
                : "menu-nonactive colors-blue"
            } p-3 text-center font-semibold tracking-wider my-5 w-3/4`}
          >
            Pemeriksaan
          </div>
          <div
            onClick={() => onFilter(1, 3)}
            className={`cursor-pointer ${
              isMenu === 3
                ? "menu-active text-white"
                : "menu-nonactive colors-blue"
            }  p-3 text-center  font-semibold tracking-wider w-2/4`}
          >
            Media
          </div>
        </div>
      ) : (
        <select
          onChange={(e) => onFilter(2, e)}
          value={isMenu}
          name="category"
          className="menu-active py-3 px-5  text-center text-white font-semibold tracking-wider  outline-none w-full pr-4"
          placeholder="Pilih kategori"
        >
          <option className="colors-gray bg-white" selected value={1}>
            Semua Pesanan
          </option>
          <option className="colors-gray bg-white" value={2}>
            Layanan Kesehatan
          </option>
          <option className="colors-gray bg-white" value={3}>
            Media Reagensia
          </option>
        </select>
      )}

      {(isMenu === 2 || isMenu === 3) && isHistory.length === 0 ? (
        <div className="w-full lg:col-span-4">
          <div className="w-full mt-10 flex flex-row content-center justify-center">
            <div className="lg:w-1/2">
              <div className="w-full flex justify-center">
                <img
                  className="mb-8 w-4/5"
                  src={
                    process.env.REACT_APP_BASE_URL +
                    "/assets/icon/ic_empty_box.svg"
                  }
                  alt="icon-empty-cart"
                />
              </div>
              <div className="w-full">
                <p className="header-content text-center colors-blue text-xl font-semibold mb-4">
                  History Transaksi Kosong
                </p>
                <p className="header-content text-center colors-gray text-base mb-8">
                  Transaksi{" "}
                  {isMenu === 2 ? "Layanan Kesehatan" : "Media Reagensia"} anda
                  masih kosong, silahkan menambahkan pembelanjaan anda
                </p>
              </div>
              <Link to={"/"}>
                <div className="flex justify-center">
                  <button className="btn-blue w-full lg:w-4/5 p-3 focus:outline-none mb-8">
                    <p className="text-white lg:text-lg">Mulai Belanja</p>
                  </button>
                </div>
              </Link>
            </div>
          </div>
        </div>
      ) : (
        // Data Ada Section
        <div className="w-full lg:col-span-4 ">
          {isHistory.map((it, index) => (
            <div
              key={index}
              className="card-history mt-5 lg:mt-0 p-4 lg:p-8 mb-5"
            >
              {/* Header Sections */}

              {size.width > 640 ? (
                <div className="flex items-center">
                  <p className="colors-gray font-bold header-title-bold ">
                    No. Invoice : {it?.invoice ?? "-"}
                  </p>
                  <div
                    className={`${
                      Number(it.status) === 0 || Number(it.status) === 3
                        ? "non-ready"
                        : Number(it.status === 1)
                        ? "progress-time"
                        : "ready"
                    } p-1 px-2 mx-5`}
                  >
                    <p
                      className={`${
                        Number(it.status) === 0
                          ? "text-red-500"
                          : Number(it.status === 1)
                          ? "text-yellow-600"
                          : Number(it.status === 3)
                          ? "text-red-700"
                          : "text-green-700"
                      } font-semibold header-content`}
                    >
                      {it.status === 4 && it.reference === 2
                        ? "Proses Pengambilan"
                        : it.status_text}
                    </p>
                  </div>
                  <p className="header-content">
                    {moment(it.created_at).format("YYYY-MM-DD HH:mm:ss")}
                  </p>
                </div>
              ) : (
                <div className="flex items-baseline justify-between ">
                  <div>
                    <p className="header-title-semi colors-gray font-bold">
                      No. {it?.invoice ?? "-"}
                    </p>
                    <div
                      className={`${
                        Number(it.status) === 0
                          ? "non-ready"
                          : Number(it.status === 1)
                          ? "progress-time"
                          : "ready"
                      } p-1 px-2 mt-2`}
                    >
                      <p
                        className={`${
                          Number(it.status) === 0
                            ? "text-red-500"
                            : Number(it.status === 1)
                            ? "text-yellow-600"
                            : "text-green-700"
                        } text-xs header-content `}
                      >
                        {it.status === 4 && it.reference === 2
                          ? "Proses Pengambilan"
                          : it.status_text}
                      </p>
                    </div>
                  </div>
                  <p className=" text-xs header-content ">
                    {moment(it.created_at).format("YYYY-MM-DD HH:mm:ss")}
                  </p>
                </div>
              )}
              {/* Content Sections */}
              <div className="lg:flex justify-between items-center my-8 lg:my-5">
                <div className="w-full lg:w-2/3">
                  {/* Content Items */}
                  {!it.grand_total ? (
                    <p className="text-3xl colors-blue font-bold mt-2">
                      Belum ada item
                    </p>
                  ) : (
                    <div>
                      {isShow.index === index && isShow.view
                        ? it.detail_item.map((item, idx) => (
                            <div
                              key={idx}
                              className="flex justify-between w-full items-center mt-4 lg:mt-3"
                            >
                              <div className="flex items-start">
                                <div>
                                  <img
                                    className="w-10 h-10 lg:w-14 lg:h-14 object-cover rounded-xl mr-3 "
                                    onError={(e) => {
                                      e.target.onerror = null;
                                      e.target.src =
                                        "/assets/image/img_empty.png"; // some replacement image
                                    }}
                                    src={
                                      process.env.REACT_APP_BACKEND_URL +
                                      "/storage/" +
                                      item.image
                                    }
                                    alt="img-media"
                                  />
                                </div>
                                <div>
                                  <p className="header-title text-sm lg:text-base colors-blue font-semibold">
                                    {item?.name ?? "Suntik Steril"}
                                  </p>
                                  <p className="header-content-semi text-sm lg:text-base colors-orange font-semibold">
                                    {"Rp. " + MoneyFormat(Number(item.harga))}
                                  </p>
                                </div>
                              </div>
                              <div className="ready lg:mr-10">
                                <p className="colors-green text-sm lg:text-base px-1 ">
                                  {item.qty}x
                                </p>
                              </div>
                            </div>
                          ))
                        : it.detail_item.slice([0], [2]).map((item, idx) => (
                            <div
                              key={idx}
                              className="flex justify-between w-full items-center mt-4 lg:mt-3"
                            >
                              <div className="flex items-start">
                                <div>
                                  <img
                                    className="w-10 h-10 lg:w-14 lg:h-14 object-cover rounded-xl mr-3 "
                                    onError={(e) => {
                                      e.target.onerror = null;
                                      e.target.src =
                                        "/assets/image/img_empty.png"; // some replacement image
                                    }}
                                    src={
                                      process.env.REACT_APP_BACKEND_URL +
                                      "/storage/" +
                                      item.image
                                    }
                                    alt="img-media"
                                  />
                                </div>
                                <div>
                                  <p className="header-title text-sm lg:text-base colors-blue font-semibold">
                                    {item?.name ?? "Suntik Steril"}
                                  </p>
                                  <p className="header-content text-sm lg:text-base colors-orange font-semibold">
                                    {"Rp. " + MoneyFormat(Number(item.harga))}
                                  </p>
                                </div>
                              </div>
                              <div className="ready lg:mr-10">
                                <p className="colors-green text-sm lg:text-base px-1 ">
                                  {item.qty}x
                                </p>
                              </div>
                            </div>
                          ))}

                      {/* Tempat Section */}
                      {it.reference === 1 && (
                        <div className="flex items-baseline lg:items-center ml-12 lg:ml-16 mt-4 lg:mt-3">
                          <img
                            className="mr-2 h-3 lg:h-3.5 w-auto"
                            src={
                              process.env.REACT_APP_BASE_URL +
                              "/assets/icon/ic_hospital.svg"
                            }
                            alt="icon-hospital"
                          />
                          <p className="header-content m-0 text-xs lg:text-sm colors-gray font-semibold">
                            Balai Besar Laboratorium Kesehatan
                          </p>
                        </div>
                      )}
                      {isShow.index === index && isShow.view
                        ? null
                        : it.detail_item.length > 2 && (
                            <div
                              onClick={() => setShow({ index, view: true })}
                              className="show-item mt-5 cursor-pointer p-2 text-center lg:mr-10"
                            >
                              <p className="font-bold colors-blue">
                                +{it.detail_item.length - 2} Item
                              </p>
                            </div>
                          )}
                    </div>
                  )}
                </div>
                <div className="lg:flex w-full lg:w-1/3 justify-between items-center h-full ">
                  <div className="line my-5 lg:mt-0 "></div>
                  <div className="text-center">
                    <p className="colors-gray header-content">Total Harga</p>
                    <p className="header-title-bold text-3xl colors-blue font-bold mt-2">
                      {it.grand_total
                        ? "Rp. " + MoneyFormat(Number(it.grand_total))
                        : "Rp. 0"}
                    </p>
                  </div>
                  <div></div>
                </div>
              </div>

              {/* Detail Section */}
              <Link
                to={`/history/detail/${
                  Number(it.reference) === 1 ? "pemeriksaan" : "pembelian"
                }/${it.transaction_id}`}
              >
                <div className="w-full flex justify-center items-center text-center colors-blue mt-5 cursor-pointer font-bold text-base">
                  <p className="colors-blue header-title-semi">
                    Lihat Detail Transaksi
                  </p>
                  <img
                    className="lg:ml-3"
                    src={
                      process.env.REACT_APP_BASE_URL +
                      "/assets/icon/ic_arrow_homepage.svg"
                    }
                    alt="icon-arrow"
                  />
                </div>
              </Link>
            </div>
          ))}
          <div className="mt-10 w-full flex justify-center">
            <div className="lg:w-1/5 home-btn-more ">
              <button
                disabled={loadMore}
                onClick={() => onPagination()}
                className="colors-blue p-3 w-full focus:outline-none"
              >
                <p className="m-0 text-white font-semibold">
                  {loadMore ? "Loading" : "Lihat Transaksi Lainnya"}
                </p>
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default History;
